import { render, staticRenderFns } from "./searchUrgentGoods.vue?vue&type=template&id=eb507a12&scoped=true&"
import script from "./searchUrgentGoods.vue?vue&type=script&lang=js&"
export * from "./searchUrgentGoods.vue?vue&type=script&lang=js&"
import style0 from "./searchUrgentGoods.vue?vue&type=style&index=0&id=eb507a12&lang=less&scoped=true&"
import style1 from "./searchUrgentGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb507a12",
  null
  
)

component.options.__file = "searchUrgentGoods.vue"
export default component.exports